import { Grid, useEventCallback } from '@mui/material';
import { memo, useMemo, useState } from 'react';
import { HeadCell } from 'shell/components/shared/table/types';
import { noop } from 'shell/utils/noop';
import Table from 'shell/components/shared/table';
import { TableFamilyVM } from './table-person';
import { FamilyVM } from '../family/family-vm';

export const headCells: HeadCell<TableFamilyVM, keyof TableFamilyVM>[] = [
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'fiscalCode',
    label: 'CF',
  },
  {
    id: 'birthDate',
    label: 'Data di nascita',
  },
  {
    id: 'birthplace',
    label: 'Luogo di nascita',
  },
  {
    id: 'residence',
    label: 'Residenza',
  },
  {
    id: 'relationshipElement',
    label: 'Parentela',
  },
  {
    id: 'drivingLicenseElement',
    label: 'Patente',
  },
  {
    id: 'autoElement',
    label: 'Auto',
  },
  {
    id: 'aireElement',
    label: 'AIRE',
  },
  {
    id: 'cfControlElement',
    label: 'Controllo dati AE',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

interface TableNewFamilyProps {
  disabled?: boolean;
  values: Array<FamilyVM>;
  onChange: (familyMembers: Array<FamilyVM>) => void;
  onDeletePress: (value: FamilyVM, index: number) => void;
}

const TableNewFamilyComponent = ({ values }: TableNewFamilyProps): React.ReactElement => {
  const [tableProps, setTableProps] = useState({
    page: 0,
    rowsPerPage: 10,
  });

  const onChangePage = useEventCallback((page: number) => {
    setTableProps({
      rowsPerPage: tableProps.rowsPerPage,
      page,
    });
  });

  const onChangeRowsPerPage = useEventCallback((rowsPerPage: number) => {
    setTableProps({
      rowsPerPage,
      page: 0,
    });
  });

  const body: Array<TableFamilyVM> = useMemo(() => {
    return values?.slice().map((item) => {
      return {
        ...item,
      };
    }) as Array<TableFamilyVM>;
  }, [values]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Table
          ariaLabel="Lista Persone"
          page={tableProps.page}
          rowsPerPage={tableProps.rowsPerPage}
          body={body}
          count={body?.length || 0}
          head={headCells}
          onSort={noop}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
          orders={{}}
          isNotLayoutFixed
          noSort
          hideButtons
        />
      </Grid>
    </Grid>
  );
};

TableNewFamilyComponent.displayName = 'Table New Family form component';

const TableNewFamily = memo(TableNewFamilyComponent);

export default TableNewFamily;
